import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearErrorCode, logout, changePassword } from '../../core/actions/authAction';
import { Button, Form, Grid, Header, Image } from 'semantic-ui-react';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import functionCommon from "../../core/common/function";

import logoUrl from '../../assets/images/logo.png';

class ChangePassword extends Component {
	constructor() {
		super();
		this.state = {
			oldPassword: '',
			password: '',
			passwordMsg: '',
			confirm: '',
			confirmMsg: '',
			submitted: '',
			errorMessageText: '',
			btnDisable: false
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ btnDisable: false });
		if (nextProps.authReducer.errorCode) {
			this.setState({ errorMessageText: "message." + nextProps.authReducer.errorCode });
		}
		if (nextProps.authReducer.successCode) {
			this.props.logout();
		}
	}

	errorMessage = (message) => {
		const { t } = this.props;
		return (
			<div className="error-message">
				{t(message)}
			</div>
		)
	}

	handleChange = (e, { name, value }) => {
		this.props.clearErrorCode();
		this.setState({ [name]: value });
		this.setState({ errorMessageText: '' });
		this.setState({passwordMsg: '' });
		this.setState({confirmMsg: '' });
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ submitted: true });
		const { password, confirm, oldPassword } = this.state;
		const isValidatePassword  = functionCommon.validatePassword(password);

		// Check validation new password
		if (password && !isValidatePassword) {
			this.setState({ passwordMsg: 'message.015' });
		}
		if (password && confirm && isValidatePassword && oldPassword) {
			if (password === confirm) {
				this.setState({ btnDisable: true });
				this.props.changePassword({ 'currentPassword': oldPassword, 'newPassword': password });
			} else {
				this.setState({ confirmMsg: 'message.007' });
			}
		}

	}
	
	render() {
		const { t } = this.props;
		const { oldPassword, password, confirm, submitted, errorMessageText, passwordMsg, confirmMsg, btnDisable } = this.state;
		return (
			<Grid textAlign='center' verticalAlign='middle' className="account-wrapper">
				<div className="account-container">
					<Grid.Column className="p-0">
						<Header textAlign='left' className="account-form-header">
							<Image src={logoUrl} className="account-form-logo" />
							<h2 className="account-form-title">{t("account.changePassword")}</h2>
						</Header>
						<Form size='large' onSubmit={this.handleSubmit} error>
							{errorMessageText ? this.errorMessage(errorMessageText) : ''}
							<Form.Input
								fluid
								icon='lock'
								iconPosition='left'
								placeholder={t("account.enterCurrentPassword")}
								type='password'
								name='oldPassword'
								onChange={this.handleChange}
							/>
							{submitted && !oldPassword &&
								<div className="error-message">
									{t("message.011")}
								</div>
							}
							<Form.Input
								fluid
								icon='lock'
								iconPosition='left'
								placeholder={t("account.enterNewPassword")}
								type='password'
								name='password'
								onChange={this.handleChange}
							/>
							{submitted && !password &&
								<div className="error-message">
									{t("message.005")}
								</div>
							}
							{submitted && passwordMsg && 
								<div className="error-message">
									{t(passwordMsg)}
								</div>
							}	
							<Form.Input
								fluid
								icon='lock'
								iconPosition='left'
								placeholder={t("account.confirmNewPassword")}
								type='password'
								name='confirm'
								onChange={this.handleChange}
							/>
							{submitted && !confirm &&
								<div className="error-message">
									{t("message.006")}
								</div>
							}
							{submitted && confirmMsg &&
								<div className="error-message">
									{t(confirmMsg)}
								</div>
							}
							<Button disabled={btnDisable} fluid size='large' className="account-form-btn">
								{t("account.saveNewPassword")}
							</Button>
						</Form>
					</Grid.Column>
				</div>
			</Grid>
		);
	}
}

const mapStateToProps = state => ({
	...state
})

const mapDispatchToProps = dispatch => ({
	clearErrorCode: () => dispatch(clearErrorCode()),
	changePassword: (data) => dispatch(changePassword(data)),
	logout: () => dispatch(logout()),
})

export default compose(
	withTranslation(),
	connect(mapStateToProps, mapDispatchToProps)
)(ChangePassword);
